<template>
    <a :class="`the-header-logo ${logoClass}`" href="/" />
</template>

<script>
import { Site } from '../enums/Site';

const MARKETSCOPES_IN_EUROPE = ['BE', 'DE', 'ES', 'FR', 'GB', 'IT', 'NL', 'PL', 'SE', 'TR'];
const MARKETSCOPES_WITH_ADVANTAGE_LOGOS = ['CA', 'DE', 'ES', 'FR', 'GB', 'IT', 'JP'];

export default {
    name: 'TheHeaderLogo',
    props: {
        marketscope: {
            type: String,
        },
        site: {
            type: String,
            validator: Site.validator,
        },
    },
    computed: {
        logoClass() {
            if (this.site === Site.ADVANTAGE) {
                return MARKETSCOPES_WITH_ADVANTAGE_LOGOS.includes(this.marketscope)
                    ? `the-header-logo-advantage-${this.marketscope.toLowerCase()}`
                    : 'the-header-logo-advantage';
            }
            return MARKETSCOPES_IN_EUROPE.includes(this.marketscope)
                ? 'the-header-logo-vendor-central-eu'
                : 'the-header-logo-vendor-central';
        },
    },
};
</script>

<style lang="scss" scoped>
.the-header-logo {
    background-repeat: no-repeat;
    background-size: contain;
    height: 32px;
    flex: 0 0 auto;

    &-advantage {
        background-image: url('src/images/advantage.png');
        width: 160px;
    }

    &-advantage-ca {
        background-image: url('src/images/advantage-ca.png');
        width: calc(152px * 32 / 35);
    }

    &-advantage-de {
        background-image: url('src/images/advantage-de.png');
        width: calc(194px * 32 / 49);
    }

    &-advantage-es {
        background-image: url('src/images/advantage-es.png');
        width: calc(149px * 32 / 34);
    }

    &-advantage-fr {
        background-image: url('src/images/advantage-fr.png');
        width: calc(194px * 32 / 53);
    }

    &-advantage-gb {
        background-image: url('src/images/advantage-gb.png');
        width: calc(149px * 32 / 38);
    }

    &-advantage-it {
        background-image: url('src/images/advantage-it.png');
        width: calc(147px * 32 / 38);
    }

    &-advantage-jp {
        background-image: url('src/images/advantage-jp.png');
        width: calc(232px * 32 / 54);
    }

    &-vendor-central {
        background-image: url('src/images/vendorCentral.png');
        width: calc(144px * 32 / 30);
    }

    &-vendor-central-eu {
        background-image: url('src/images/vendorCentral-eu.png');
        width: calc(219px * 32 / 31);
    }
}
</style>
